function SectionHeading({ eyebrow, title, lede, dark = false, center = false }) {
  if (center) {
    return (
      <div className="reveal mx-auto max-w-3xl text-center" data-reveal>
        {eyebrow && <span className={`eyebrow ${dark ? 'eyebrow-dark' : ''}`}>{eyebrow}</span>}
        <h2 className={`display-lg mt-4 ${dark ? 'text-white' : 'text-ink'}`}>{title}</h2>
        {lede && <p className={`lede mx-auto mt-5 ${dark ? 'text-subtle' : 'text-muted'}`}>{lede}</p>}
      </div>
    );
  }

  return (
    <div className="reveal grid gap-6 lg:grid-cols-12 lg:items-end" data-reveal>
      <div className="lg:col-span-7">
        {eyebrow && <span className={`eyebrow ${dark ? 'eyebrow-dark' : ''}`}>{eyebrow}</span>}
        <h2 className={`display-lg mt-4 ${dark ? 'text-white' : 'text-ink'}`}>{title}</h2>
      </div>
      {lede && (
        <p className={`lede lg:col-span-5 ${dark ? 'text-subtle' : 'text-muted'}`}>{lede}</p>
      )}
    </div>
  );
}

export default SectionHeading;
